<template>
  <b-container fluid class="pl-0 pr-0" id="app">
    <navbar v-if="$route.meta.requiresAuth"></navbar>
    <router-view />
  </b-container>
</template>

<script>
import Navbar from "./components/Navbar";
import { controlFrontendVersion, getAxiosFunctions } from "./utils/axiosUtil";

export default {
  components: {
    Navbar
  },
  mounted() {
    let axiosFunctions = getAxiosFunctions(this.$http);
    controlFrontendVersion(axiosFunctions);
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
